import { Place } from "../../../types/place";
import { EntitySelectionProps } from "../EntitySelectionInput";
import EntitySelectionModal from "../../modals/EntitySelectionModal";
import { constructFullId } from "../../../common/entities/EntityUtils";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import { placeColumns } from "../../../common/entities/PlaceColumns";
import usePlaceQuery from "../../../hooks/query/usePlaceQuery";

const PlaceSelectionModal: React.FC<EntitySelectionProps<Place>> = ({
  open,
  initialSelectedEntity,
  onClose,
  handleEntitySelect,
  required,
}) => {
  const { useFetchAll } = usePlaceQuery();
  const { data, isLoading, pagination, setPagination, errorMessage } =
    useFetchAll({ enabled: open });

  return (
    <EntitySelectionModal
      open={open}
      onClose={onClose}
      title="Select Place"
      columns={placeColumns}
      error={errorMessage}
      data={data?.data || []}
      loading={isLoading}
      pagination={pagination}
      onPaginationChange={setPagination}
      onSelect={handleEntitySelect}
      totalRowCount={data?.total || 0}
      initialSelectedEntity={initialSelectedEntity}
      required={required}
    />
  );
};

const renderPlaceSelection = (props: EntitySelectionProps<Place>) => (
  <PlaceSelectionModal {...props} />
);

export default renderPlaceSelection;

export const createPlaceSelectionHandler = (
  onChange: (value: any) => void,
  value: any,
  setSelectedPlace: (place: Place | null) => void
) => {
  return (e: { target: { value: Place | null; name?: string } }) => {
    const place = e.target.value;

    if (!place) {
      onChange({
        ...value,
        place: "",
      });
      setSelectedPlace(null);
      return;
    }

    const placeId =
      place._id || constructFullId(SystemEntityCollections.PLACE, place._key);
    setSelectedPlace(place);
    onChange({
      ...value,
      place: placeId,
    });
  };
};
